import s from './MoneyLoader.module.css';

const MoneyLoader = () => {
  return (
    <div className={s.div}>
      <span className={s.loader}></span>
    </div>
  );
};

export default MoneyLoader;
